var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBids(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 489,
    viewBox: "0 0 533 489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.25 111.688H214.75L176.793 52.6689C171.107 43.7871 177.193 32 187.443 32H344.557C354.807 32 360.893 43.7871 355.207 52.6689L317.25 111.688ZM214.75 138.25H317.25C320.293 140.325 323.736 142.649 327.66 145.223C373.064 175.354 471 240.267 471 377.312C471 421.307 436.566 457 394.125 457H137.875C95.4336 457 61 421.307 61 377.312C61 240.267 158.936 175.354 204.34 145.223C208.184 142.649 211.707 140.325 214.75 138.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.246 299.714C197.2 300.944 197.2 302.128 197.2 303.357V310.643C197.2 311.872 197.2 313.056 197.246 314.286H189.8C181.614 314.286 175 320.797 175 328.857C175 336.917 181.614 343.429 189.8 343.429H202.889C216.579 381.633 253.625 409 297.1 409H308.2C316.386 409 323 402.488 323 394.429C323 386.369 316.386 379.857 308.2 379.857H297.1C270.321 379.857 247.058 365.104 235.171 343.429H293.4C301.586 343.429 308.2 336.917 308.2 328.857C308.2 320.797 301.586 314.286 293.4 314.286H226.892C226.846 313.102 226.8 311.872 226.8 310.643V303.357C226.8 302.128 226.846 300.898 226.892 299.714H293.4C301.586 299.714 308.2 293.203 308.2 285.143C308.2 277.083 301.586 270.571 293.4 270.571H235.171C247.058 248.896 270.321 234.143 297.1 234.143H308.2C316.386 234.143 323 227.631 323 219.571C323 211.512 316.386 205 308.2 205H297.1C253.625 205 216.579 232.367 202.889 270.571H189.8C181.614 270.571 175 277.083 175 285.143C175 293.203 181.614 299.714 189.8 299.714H197.246Z",
    fill: "#637DF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 410,
    height: 425,
    fill: "white",
    transform: "translate(61 32)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBids);
export default __webpack_public_path__ + "static/media/bids.9d9bf9d471576ae1408e6dd007342c8f.svg";
export { ForwardRef as ReactComponent };